import React, { Component } from 'react'
import { Container, } from 'semantic-ui-react'
import SideMenu from './SideMenu'
import OrderTable from './OrderTable'
import { getPrintValues, checkAdminEmail } from './newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { firebaseAuth, logDashboardAction, logDashboardLogin } from '../../config/constants';


export default class DashBoardContainer extends Component {

    constructor(props) {
        super(props);
        console.log(this.props);
        console.log(" ddcx1 DashBoardContainer - got user:" + this.props.user);
        console.log(" ddcx12 DashBoardContainer - got admin:" + this.props.admin);
        console.log(" ddcx13 DashBoardContainer +++++++++++:");

        this.state = {
            orderType: 'all',
            searchNumberText: '',
            algoliaUser: null,
            orderStatuses: [],
        }
    }

    udpateTableView = (orderType) => {
        console.log("upx1 ++++++++++:udpateTableView");
        console.log("upx12 orderType:" + orderType);

        this.setState({
            orderType: orderType
        })
    }


    handleTextChange = (e) => {
        console.log("ix32 e.target.name:" + e.target.name);
        console.log("ix34 e.target.value:" + e.target.value);
        this.setState({
            searchNumberText: e.target.value
        })
    }

    searchNumber = () => {
        console.log("++++++ searchNumber log");
        console.log("searchNumberText:" + this.state.searchNumberText);
    }



    componentDidMount() {
        console.log("Maddx13 ++++++ componentDidMount ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("maddx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })

        getPrintValues("statuses", this.loadStatuses);
        //getPrintValues("adminemail", this.loadAdmins);
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        if (returnObject.algoliaUser && returnObject.algoliaUser.isAdmin) {
            // console.log("mdbrx16 returnObject.algoliaUser && returnObject.algoliaUser.isAdmin:"); 

            logDashboardLogin(returnObject.algoliaUser.key, `${window.navigator.userAgent}`, "loaded_dashboard", "dashboard");

            // logDashboardAction(returnObject.algoliaUser.key+" loaded login dashboard"+` device: ${window.navigator.userAgent}`, returnObject.algoliaUser.key,null,"dashBoard");
        }

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }



    // setAdmin = (user) => {
    //     console.log("++++++ Maddx2 setAdmin");
    //     console.log("Maddx121 setAdmin:" + user.email);
    //     this.setState({
    //         authed: true,
    //         // loading: false,
    //         user: user,
    //         uid: user.uid,
    //         isAdmin: true
    //     })
    // }

    loadStatuses = (statuses) => {
        //console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:"+JSON.stringify(statuses, null, 3));
        this.setState({ orderStatuses: statuses })
    }

    // loadAdmins = (statuses) => {
    //     console.log("addx12 ++++++ admins ");
    //     console.log("addx121 admins:" + JSON.stringify(statuses, null, 3));
    //     this.setState({ admins: statuses })
    // }

    render() {

        const sideMenuGrid = this.state.user && this.state.user.email
            ? (
                // <Grid.Column width={3}>
                <SideMenu
                    searchNumber={this.searchNumber}
                    handleTextChange={this.handleTextChange}
                    udpateTableFunction={this.udpateTableView}
                    user={this.state.user} />
                //</Grid.Column>
            )
            : ''


        const dataTableGrid = (
            // <Grid.Column width={12}>
            <OrderTable orderType={this.state.orderType}
                orderStatuses={this.state.orderStatuses}
                user={this.state.user}
                algoliaUser={this.state.algoliaUser} />
            // </Grid.Column>
        )


        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <div>

                {sideMenuGrid}
                {dataTableGrid}

            </div>
            : <div><h2>An error occurred...</h2>{userEmail}</div>

        return (
            <Container>

                {/* {sideMenuGrid}
                {dataTableGrid} */}

                {wholeUI}

                {/* <Grid>
                    {sideMenuGrid}
                    {dataTableGrid}
                </Grid> */}
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/DashBoardContainer.js